<template>
    <div>
        <h1 style="font-size: 24px; color: black;">游戏日报
        <span >用户类型：</span>
        <el-select v-model="queryData.user"   clearable placeholder="请选择" >
            <el-option v-for="item in users" :label="item.name" :key="item.id" :value="item.id" ></el-option>
        </el-select>
        <el-button class="sub-sub4"  type="primary" icon="el-icon-share" @click="jumpUserBehaviorPage">用户行为对比分析</el-button>
        <el-button class="sub-sub4"  type="primary" icon="el-icon-share" @click="jumpUserGamePage">用户游戏个数分布</el-button>
        <el-button class="sub-sub4"  type="primary" icon="el-icon-share" @click="jumpAdReportPage">广告数据报表</el-button>
        <el-row style="line-height: 1rem;">
        <el-checkbox v-model="checkAll" style="width: 120px"  @change="handleCheckAllChange ">全部</el-checkbox>
        <el-checkbox  style="width: 120px"  @change="tableKey=tableKey+1" v-model="queryTrueData.isR6Rate">6留存率</el-checkbox>
        <el-checkbox  style="width: 120px"  @change="tableKey=tableKey+1" v-model="queryTrueData.isR7Rate">7留存率</el-checkbox>
        <el-checkbox  style="width: 120px"  @change="tableKey=tableKey+1" v-model="queryTrueData.isR15Rate">15留存率</el-checkbox>
        <el-checkbox  style="width: 120px"  @change="tableKey=tableKey+1" v-model="queryTrueData.isR30Rate">30留存率</el-checkbox>
        <el-checkbox  style="width: 120px"  @change="tableKey=tableKey+1" v-model="queryTrueData.isTotalUser">累计用户</el-checkbox>
        <el-checkbox  style="width: 120px"  @change="tableKey=tableKey+1" v-model="queryTrueData.isGreater5s">游戏超5秒用户</el-checkbox>
        <el-checkbox  style="width: 120px"  @change="tableKey=tableKey+1" v-model="queryTrueData.isAppGreater5s">活跃超5秒用户</el-checkbox>
        <el-checkbox  style="width: 120px"  @change="tableKey=tableKey+1" v-model="queryTrueData.isPerClickGames">人均点击游戏数</el-checkbox>
        <el-checkbox  style="width: 120px"  @change="tableKey=tableKey+1" v-model="queryTrueData.isActUserRate">游戏活跃用户</el-checkbox>
        <el-checkbox  style="width: 120px"  @change="tableKey=tableKey+1" v-model="queryTrueData.isTotalGame">游戏总数量</el-checkbox>
        <el-checkbox  style="width: 120px"  @change="tableKey=tableKey+1" v-model="queryTrueData.isExGame">总曝光个数</el-checkbox>
        <el-checkbox  style="width: 120px"  @change="tableKey=tableKey+1" v-model="queryTrueData.isOpenGame">活跃游戏数量</el-checkbox>
        <el-checkbox  style="width: 120px"  @change="tableKey=tableKey+1" v-model="queryTrueData.isJumpTimesRate">导出率次数</el-checkbox>
        <el-checkbox  style="width: 120px"  @change="tableKey=tableKey+1" v-model="queryTrueData.isPerShowTimes">人均展示次数</el-checkbox>
        <el-checkbox  style="width: 120px"  @change="tableKey=tableKey+1" v-model="queryTrueData.isLess1Rate">活跃1分钟以内用户</el-checkbox>
        <el-checkbox  style="width: 120px"  @change="tableKey=tableKey+1" v-model="queryTrueData.isLess2Rate">活跃1-2分钟用户</el-checkbox>
        <el-checkbox  style="width: 120px"  @change="tableKey=tableKey+1" v-model="queryTrueData.isLess3Rate">活跃2-3分钟用户</el-checkbox>
        <el-checkbox  style="width: 120px"  @change="tableKey=tableKey+1" v-model="queryTrueData.isLess4Rate">活跃3-4分钟用户</el-checkbox>
        <el-checkbox  style="width: 120px"  @change="tableKey=tableKey+1" v-model="queryTrueData.isLess5Rate">活跃4-5分钟用户</el-checkbox>
        <el-checkbox  style="width: 120px"  @change="tableKey=tableKey+1" v-model="queryTrueData.isMore5Rate">活跃超过5分钟用户</el-checkbox>
        <el-checkbox  style="width: 120px"  @change="tableKey=tableKey+1" v-model="queryTrueData.isExUser">曝光用户数</el-checkbox>
        <el-checkbox  style="width: 120px"  @change="tableKey=tableKey+1" v-model="queryTrueData.isExUserOpen">曝光用户点击数</el-checkbox>
        <el-checkbox  style="width: 120px"  @change="tableKey=tableKey+1" v-model="queryTrueData.isExUserOpenRate">曝光用户打开率</el-checkbox>
        <el-checkbox  style="width: 120px"  @change="tableKey=tableKey+1" v-model="queryTrueData.isPerVideoRate">人均广告视频次数</el-checkbox>
        <el-checkbox  style="width: 120px"  @change="tableKey=tableKey+1" v-model="queryTrueData.isJumpRate">导出率</el-checkbox>
        <el-checkbox  style="width: 120px"  @change="tableKey=tableKey+1" v-model="queryTrueData.isOpen">总频次</el-checkbox>
        <el-checkbox  style="width: 120px"  @change="tableKey=tableKey+1" v-model="queryTrueData.isVideoOpen">总广告视频数</el-checkbox>
        <el-checkbox  style="width: 120px"  @change="tableKey=tableKey+1" v-model="queryTrueData.isOnline">总时长</el-checkbox>
        <el-checkbox  style="width: 120px"  @change="tableKey=tableKey+1" v-model="queryTrueData.isEcpm">ECPM</el-checkbox>
        <el-checkbox  style="width: 120px"  @change="tableKey=tableKey+1" v-model="queryTrueData.isPerValue">单UV价值</el-checkbox>
        <el-checkbox  style="width: 120px"  @change="tableKey=tableKey+1" v-model="queryTrueData.isArpu">贡献arpu</el-checkbox>
        <el-checkbox  style="width: 120px"  @change="tableKey=tableKey+1" v-model="queryTrueData.isSubChannelName">子渠道名称</el-checkbox>
        <el-checkbox  style="width: 120px"  @change="tableKey=tableKey+1" v-model="queryTrueData.isVideoRequestOpen">总广告视频请求数</el-checkbox>
        <el-checkbox  style="width: 120px"  @change="tableKey=tableKey+1" v-model="queryTrueData.isPerVideoRequestTimes">人均广告视频请求次数</el-checkbox>
        </el-row>
    </h1>
        <div class="block" >
        <span >游戏名称：</span>
            <el-select v-model="queryData.gameIds" multiple  filterable placeholder="请选择/输入">
                <el-option
                        v-for="item in gameList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                </el-option>
            </el-select>
        &emsp;
        <span > 游戏标签：</span>
                    <el-cascader v-model="queryData.gameLabels" :options="labelList" :props="{ key:'id',value:'id', label:'name',multiple:true }" clearable collapse-tags></el-cascader>
        &emsp;
        <span class="demonstration">日期：</span>
        <el-date-picker
                v-model="queryData.timeDate"
                type="daterange"
:clearable="false"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd">
        </el-date-picker>&emsp;&emsp;
                <span >渠道：</span>
                <el-select v-model="queryData.channelId"  @change="selectGoodsByChannelId($event)" clearable placeholder="请选择" multiple>
                    <el-option value="0" label="全部"></el-option>
                    <el-option v-for="item in channelList" :label="item.name" :key="item.id" :value="item.id"></el-option>
                </el-select>
                <el-select v-model="queryData.subChannelId"   clearable placeholder="请选择" multiple filterable @change="checkParam($event)">
                    <el-option value="0" label="全部"></el-option>
                    <el-option v-for="item in subChannelList" :label="item.name" :key="item.id" :value="item.subChannel" :disabled="item.disabled"></el-option>
                </el-select>
                <el-button class="std" type="primary"  @click="query()" >查询</el-button>
                <el-button class="std" type="primary"  @click="exportExcel()" >导出</el-button>
        </div>
        <h1>
            <el-table :key="tableKey"
                      border
                      :data="gameReportList"
                      :header-cell-style="{background:'#282828'}"
                      ref="filterTable"
                      @sort-change='sortChange'
                      max-height="820" >
                <el-table-column  prop="dt" label="日期" sortable="custom"></el-table-column>
                <el-table-column  prop="name"   label="游戏名称"></el-table-column>
                <el-table-column
                                    :formatter="formatGameLabels"
                                    :show-overflow-tooltip="true"
                                    prop="gameLabelNames"
                                    label="游戏标签">
                            </el-table-column>
                <el-table-column v-if="queryTrueData.isSubChannelName" label="子渠道名称" :key="Math.random()">
                    <template slot-scope="scope">
                        <span>{{scope.row.subChannelName===null?'------': scope.row.subChannelName}}</span>
                    </template>
                </el-table-column>
                <el-table-column  prop="newUser" label="新增" sortable="custom"></el-table-column>
                <el-table-column  prop="user" label="活跃" sortable="custom"></el-table-column>
                <el-table-column  label="次留率" prop="r1Rate" sortable="custom">
                    <template slot-scope="scope">
                    {{ scope.row.r1Rate == null ? '0.00%' : (scope.row.r1Rate * 100).toFixed(2) + '%' }}
                    </template>
                </el-table-column>
                <el-table-column  label="3留率"  prop="r2Rate" sortable="custom">
                    <template slot-scope="scope" >
                        {{ scope.row.r2Rate == null ? '0.00%' : (scope.row.r2Rate * 100).toFixed(2) + '%' }}
                    </template>
                </el-table-column>
                <el-table-column  label="4留存率" prop="r3Rate" sortable="custom" >
                    <template slot-scope="scope" >
                        {{ scope.row.r3Rate == null ? '0.00%' : (scope.row.r3Rate * 100).toFixed(2) + '%' }}
                    </template>
                </el-table-column>
                <el-table-column  label="5留存率"  prop="r4Rate" sortable="custom">
                    <template slot-scope="scope" >
                        {{ scope.row.r4Rate == null ? '0.00%' : (scope.row.r4Rate * 100).toFixed(2) + '%' }}
                    </template>
                </el-table-column>

                <el-table-column   label="人均游戏个数"  prop="perGames" sortable="custom">
                    <template slot-scope="scope" >
                        {{scope.row.gameId!==-1 ?'— —':(scope.row.perGames==null ? '0.00':scope.row.perGames.toFixed(2))}}
                    </template>
                </el-table-column>

                <el-table-column   label="人均游戏时长(分钟)"  prop="perOnline" sortable="custom">
                    <template  slot-scope="scope" >
                        {{scope.row.perOnline==null?'0.00': scope.row.perOnline.toFixed(2)}}
                    </template>
                </el-table-column>

                <el-table-column  label="人均游戏频次" prop="perGameTimes"  sortable="custom" >
                    <template  slot-scope="scope" >
                        {{scope.row.perGameTimes==null ? '0.00':scope.row.perGameTimes.toFixed(2)}}
                    </template>
                </el-table-column>

                <el-table-column v-if="queryTrueData.isR6Rate" label="6留存率" :key="Math.random()" >
                    <template slot-scope="scope" >
                        {{ scope.row.r5Rate == null ? '0.00%' : (scope.row.r5Rate * 100).toFixed(2) + '%' }}
                    </template>
                </el-table-column>
                <el-table-column v-if="queryTrueData.isR7Rate"  label="7留存率" :key="Math.random()" >
                    <template slot-scope="scope" >
                        {{ scope.row.r6Rate == null ? '0.00%' : (scope.row.r6Rate * 100).toFixed(2) + '%' }}
                    </template>
                </el-table-column>
                <el-table-column v-if="queryTrueData.isR15Rate" label="15留存率" :key="Math.random()">
                    <template slot-scope="scope" >
                        {{ scope.row.r15Rate == null ? '0.00%' : (scope.row.r15Rate * 100).toFixed(2) + '%' }}
                    </template>
                </el-table-column>
                <el-table-column v-if="queryTrueData.isR30Rate" label="30留存率" :key="Math.random()">
                    <template slot-scope="scope" >
                        {{ scope.row.r30Rate == null ? '0.00%' : (scope.row.r30Rate * 100).toFixed(2) + '%' }}
                    </template>
                </el-table-column>
                <el-table-column v-if="queryTrueData.isTotalUser" prop="totalUser" label="累计用户" :key="Math.random()"></el-table-column>
                <el-table-column v-if="queryTrueData.isGreater5s" :key="Math.random()" label="游戏超5秒用户">
                    <template slot-scope="scope" >
                        {{scope.row.gameId!==-1 ?'— —':scope.row.greater5s}}
                    </template>
                </el-table-column>
                <el-table-column v-if="queryTrueData.isAppGreater5s"  label="活跃超5秒用户">
                    <template slot-scope="scope" >
                        {{scope.row.gameId!==-1 ?'— —':scope.row.appGreater5s}}
                    </template>
                </el-table-column>
                <el-table-column v-if="queryTrueData.isPerClickGames"  label="人均点击游戏数">
                    <template slot-scope="scope" >
                        {{scope.row.gameId!==-1 ?'— —':scope.row.perClickGames==null?'0.00':scope.row.perClickGames.toFixed(2)}}
                    </template>
                </el-table-column>
                <el-table-column v-if="queryTrueData.isActUserRate" label="游戏活跃用户">
                    <template slot-scope="scope" >
                        {{scope.row.gameId!==-1 ?'— —':scope.row.actUserRate==null?'0.00%':(scope.row.actUserRate*100).toFixed(2)+'%'}}
                    </template>
                </el-table-column>
                <el-table-column v-if="queryTrueData.isTotalGame"  label="游戏总数量">
                    <template slot-scope="scope" >
                        {{scope.row.gameId!==-1 ?'— —':scope.row.totalGame}}
                    </template>
                </el-table-column>
                <el-table-column v-if="queryTrueData.isExGame"   label="总曝光个数">
                    <template slot-scope="scope" >
                        {{scope.row.gameId!==-1 ?'— —':scope.row.exGame}}
                    </template>
                </el-table-column>
                <el-table-column v-if="queryTrueData.isOpenGame"  label="活跃游戏数量">
                    <template slot-scope="scope" >
                        {{scope.row.gameId!==-1 ?'— —':scope.row.openGame}}
                    </template>
                </el-table-column>
                <el-table-column v-if="queryTrueData.isJumpTimesRate"   label="导出率次数">
                    <template slot-scope="scope" >
                        {{scope.row.gameId === -1 ?'— —':scope.row.jumpTimesRate==null?'0.00%':(scope.row.jumpTimesRate*100).toFixed(2)+'%'}}
                    </template>
                </el-table-column>
                <el-table-column v-if="queryTrueData.isPerShowTimes"  label="人均展示次数">
                    <template slot-scope="scope" >
                        {{scope.row.perShowTimes == null ? '0.00%' : scope.row.perShowTimes.toFixed(2)}}
                    </template>
                </el-table-column>
                <el-table-column v-if="queryTrueData.isLess1Rate"   label="活跃1分钟内用户">
                    <template slot-scope="scope" >
                        {{ scope.row.less1Rate == null ? '0.00%' : (scope.row.less1Rate * 100).toFixed(2) + '%' }}
                    </template>
                </el-table-column>
                <el-table-column v-if="queryTrueData.isLess2Rate"   label="活跃1-2分钟用户">
                    <template slot-scope="scope" >
                        {{ scope.row.less2Rate == null ? '0.00%' : (scope.row.less2Rate * 100).toFixed(2) + '%' }}
                    </template>
                </el-table-column>
                <el-table-column v-if="queryTrueData.isLess3Rate"   label="活跃2-3分钟用户">
                    <template slot-scope="scope" >
                        {{ scope.row.less3Rate == null ? '0.00%' : (scope.row.less3Rate * 100).toFixed(2) + '%' }}
                    </template>
                </el-table-column>
                <el-table-column v-if="queryTrueData.isLess4Rate"   label="活跃3-4分钟用户">
                    <template slot-scope="scope" >
                        {{ scope.row.less4Rate == null ? '0.00%' : (scope.row.less4Rate * 100).toFixed(2) + '%' }}
                    </template>
                </el-table-column>
                <el-table-column v-if="queryTrueData.isLess5Rate" :key="Math.random()"  label="活跃4-5分钟用户">
                    <template slot-scope="scope" >
                        {{ scope.row.less5Rate == null ? '0.00%' : (scope.row.less5Rate * 100).toFixed(2) + '%' }}
                    </template>
                </el-table-column>
                <el-table-column v-if="queryTrueData.isMore5Rate"   label="活跃超过5分钟用户">
                    <template slot-scope="scope" >
                        {{ scope.row.more5Rate == null ? '0.00%' : (scope.row.more5Rate * 100).toFixed(2) + '%' }}
                    </template>
                </el-table-column>

                <el-table-column v-if=" queryTrueData.isExUser"  label="曝光用户数">
                    <template slot-scope="scope" >
                        {{scope.row.gameId===-1?'— —': scope.row.exUser==null?0:scope.row.exUser}}
                    </template>
                </el-table-column>

                <el-table-column v-if=" queryTrueData.isExUserOpen"  label="曝光用户点击数">
                    <template slot-scope="scope">
                        {{scope.row.gameId===-1?'— —': scope.row.exUserOpen==null?0:scope.row.exUserOpen}}
                    </template>
                </el-table-column>

                <el-table-column v-if=" queryTrueData.isExUserOpenRate"  label="曝光用户打开率">
                    <template  slot-scope="scope" >
                        {{scope.row.gameId===-1?'— —':(scope.row.exUserOpenRate==null?'0.00%':(scope.row.exUserOpenRate*100).toFixed(2)+'%')}}
                    </template>
                </el-table-column>

                <el-table-column v-if=" queryTrueData.isOnline"  label="总时长(小时)">
                    <template slot-scope="scope" >
                        {{scope.row.onLine==null?'0.00':scope.row.onLine.toFixed(2)}}
                    </template>
                </el-table-column>

                <el-table-column v-if=" queryTrueData.isOpen"  label="总频次">
                    <template  slot-scope="scope">
                        {{scope.row.open==null?'0.00':scope.row.open}}
                    </template>
                </el-table-column>

                <el-table-column v-if=" queryTrueData.isVideoOpen"    label="总广告视频数">
                    <template  slot-scope="scope">
                        {{scope.row.videoOpen==null?'0.00':scope.row.videoOpen}}
                    </template>
                </el-table-column>

                <el-table-column v-if=" queryTrueData.isPerVideoRate"  prop="perVideoRate" label="人均广告视频次数" sortable="custom">
                    <template   slot-scope="scope" >
                        {{scope.row.perVideoRate==null?'0.00':scope.row.perVideoRate.toFixed(2)}}
                    </template>
                </el-table-column>
                <el-table-column v-if=" queryTrueData.isJumpRate"   label="导出率">
                    <template   slot-scope="scope" >
                        {{scope.row.gamId === -1 ?'— —':(scope.row.jumpRate==null?'0.00%':(scope.row.jumpRate *100).toFixed(2)+'%')}}
                    </template>
                </el-table-column>
                <el-table-column v-if=" queryTrueData.isPerVideoRequestTimes" prop="perVideoRequestTimes" label="人均广告视频请求次数" sortable="custom">
                    <template   slot-scope="scope" >
                        {{scope.row.perVideoRequestTimes==null?'0.00':scope.row.perVideoRequestTimes.toFixed(2)}}
                    </template>
                </el-table-column>
                <el-table-column v-if=" queryTrueData.isVideoRequestOpen"    label="总广告视频请求数">
                    <template  slot-scope="scope">
                        {{scope.row.videoRequest==null?'0.00':scope.row.videoRequest}}
                    </template>
                </el-table-column>
                <el-table-column v-if=" queryTrueData.isPerValue" prop="perValue" label="单UV价值" sortable="custom">
                    <template   slot-scope="scope" >
                        {{scope.row.perValue==null?'0.00':scope.row.perValue.toFixed(2)}}
                    </template>
                </el-table-column>
                <el-table-column v-if=" queryTrueData.isEcpm" prop="ecpm" label="ECPM" sortable="custom">
                    <template   slot-scope="scope" >
                        {{scope.row.ecpm==null?'0.00':scope.row.ecpm.toFixed(2)}}
                    </template>
                </el-table-column>
                <el-table-column v-if=" queryTrueData.isArpu" prop="arpu" label="贡献arpu" sortable="custom">
                    <template   slot-scope="scope" >
                        {{scope.row.arpu==null?'0.00':scope.row.arpu.toFixed(2)}}
                    </template>
                </el-table-column>

            </el-table>
            <el-row>
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="queryInfo.pagenum"
                        :page-sizes="[20,30,50]"
                        :page-size="queryInfo.pagesize"
                        layout="total, sizes, prev, pager, next"
                        :total="queryInfo.total">
                </el-pagination>
            </el-row>
        </h1>
    </div>
</template>

<script>
    import {
        allGameLabels,
        downloadData,
        channelList,
        gameSimpleList,
        gameSearchGameReport,
    } from "@/http/api";
    import utils from '@/utils'

    export default {
        inject:['reload'],
        name: "DataReport",
        data(){
            return{
                isIndeterminate: true,
                checkAll: false,
                
                tableKey:1,
                labelList:[],
                queryData:{
                    user:0,
                    gameIds:[],
                    gameLabelIds:[],
                    gameLabels:[],
                    channelId:[],
                    subChannelId:[],
                    timeDate:['',''],
                },
                queryInfo:{
                    pagesize:20,
                    pagenum:1,
                    total:0,
                },
                users:[{id:0,name:'全部'},
                     {id:1,name:'新用户'},
                     {id:2,name:'老用户'}],
                subQueryData:{
                },
                queryTrueData:{
                    user:0,
                    gameIds:[],
                    gameLabelIds:[],
                    gameLabels:[],
                    channelId:[],
                    subChannelId:[],
                    startTime:'',
                    endTime:'',
                    order:'ascending',
                    prop:'dt',
                    isR6Rate:false,
                    isR7Rate: false,
                    isR15Rate: false,
                    isR30Rate: false,
                    isTotalUser: false,
                    isGreater5s: false,
                    isAppGreater5s: false,
                    isPerClickGames: false,
                    isActUserRate: false,
                    isTotalGame: false,
                    isExGame: false,
                    isOpenGame: false,
                    isJumpTimesRate: false,
                    isPerShowTimes: false,
                    isLess1Rate: false,
                    isLess2Rate: false,
                    isLess3Rate: false,
                    isLess4Rate: false,
                    isLess5Rate: false,
                    isMore5Rate: false,
                    isExUser: false,
                    isExUserOpen: false,
                    isExUserOpenRate: false,
                    isPerVideoRate: false,
                    isJumpRate: false,
                    isOpen: false,
                    isVideoOpen: false,
                    isOnline: false,
                    isSubChannelName: false,
                    isVideoRequestOpen: false,
                    isPerVideoRequestTimes :false,
                    isArpu: false,
                    isPerValue: false,
                    isEcpm :false
                },
                gameReportList:[],
                gameList:[],
                channelList:[],
                subChannelList:[],
                watchTag:'',
            }
        },
        methods:{
            formatGameLabels: function(row, column, cellValue) {
                var name="无";
                if(cellValue!=null && cellValue.length>0){
                   return  cellValue  ;
                } 
                return name;
            },
            selectGoodsByChannelId(val){
                if(val.length===1){
                    val = val[0]
                }else{
                    this.subChannelList=[];
                    return;
                }
                this.watchTag = val;
                if(val !== null && val !== '' && val !== undefined && val !=='0') {
                    this.subChannelList = this.channelList.filter(channel => channel.id === val )[0].children.filter(subChannel=>subChannel.state===1);
                }
                if (val==='0'){
                    this.subChannelList=[];
                }
            },

            handleSizeChange(newSize){
                this.queryInfo.pagesize=newSize;
                this.queryGameReportList();
            },

            handleCurrentChange(newPage){
                this.queryInfo.pagenum=newPage;
                this.queryGameReportList();
            },
            query(){
                this.queryInfo.pagenum=1;
                this.queryGameReportList();
            },
            checkParam(val){
                let _this = this;
                if (val.indexOf('0') > -1){
                    this.subChannelList.forEach(function (subChannel) {
                        _this.$set(subChannel,'disabled',true);
                        _this.queryData.subChannelId=['0']
                    });
                }else {
                    this.subChannelList.forEach(function (subChannel) {
                        _this.$set(subChannel,'disabled',false);
                    });
                }

            },

            handleCheckAllChange(val){
                this.isIndeterminate = false;
                if (val){
                    this.queryTrueData.isR6Rate=         true;
                    this.queryTrueData.isR7Rate=         true;
                    this.queryTrueData.isR15Rate=        true;
                    this.queryTrueData.isR30Rate=        true;
                    this.queryTrueData.isTotalUser=      true;
                    this.queryTrueData.isGreater5s=      true;
                    this.queryTrueData.isAppGreater5s=   true;
                    this.queryTrueData.isPerClickGames=  true;
                    this.queryTrueData.isActUserRate=    true;
                    this.queryTrueData.isTotalGame=      true;
                    this.queryTrueData.isExGame=         true;
                    this.queryTrueData.isOpenGame=       true;
                    this.queryTrueData.isJumpTimesRate=  true;
                    this.queryTrueData.isPerShowTimes=   true;
                    this.queryTrueData.isLess1Rate=      true;
                    this.queryTrueData.isLess2Rate=      true;
                    this.queryTrueData.isLess3Rate=      true;
                    this.queryTrueData.isLess4Rate=      true;
                    this.queryTrueData.isLess5Rate=      true;
                    this.queryTrueData.isMore5Rate=      true;
                    this.queryTrueData.isExUser=         true;
                    this.queryTrueData.isExUserOpen=     true;
                    this.queryTrueData.isExUserOpenRate= true;
                    this.queryTrueData.isPerVideoRate=   true;
                    this.queryTrueData.isJumpRate=       true;
                    this.queryTrueData.isOpen=           true;
                    this.queryTrueData.isVideoOpen=      true;
                    this.queryTrueData.isOnline=         true;
                    this.queryTrueData.isSubChannelName= true;
                    this.queryTrueData.isVideoRequestOpen = true;
                    this.queryTrueData.isPerVideoRequestTimes = true;
                    this.queryTrueData.isArpu = true;
                    this.queryTrueData.isPerValue = true;
                    this.queryTrueData.isEcpm =  true;
                }else {
                    this.queryTrueData.isR6Rate=         false;
                    this.queryTrueData.isR7Rate=         false;
                    this.queryTrueData.isR15Rate=        false;
                    this.queryTrueData.isR30Rate=        false;
                    this.queryTrueData.isTotalUser=      false;
                    this.queryTrueData.isGreater5s=      false;
                    this.queryTrueData.isAppGreater5s=   false;
                    this.queryTrueData.isPerClickGames=  false;
                    this.queryTrueData.isActUserRate=    false;
                    this.queryTrueData.isTotalGame=      false;
                    this.queryTrueData.isExGame=         false;
                    this.queryTrueData.isOpenGame=       false;
                    this.queryTrueData.isJumpTimesRate=  false;
                    this.queryTrueData.isPerShowTimes=   false;
                    this.queryTrueData.isLess1Rate=      false;
                    this.queryTrueData.isLess2Rate=      false;
                    this.queryTrueData.isLess3Rate=      false;
                    this.queryTrueData.isLess4Rate=      false;
                    this.queryTrueData.isLess5Rate=      false;
                    this.queryTrueData.isMore5Rate=      false;
                    this.queryTrueData.isExUser=         false;
                    this.queryTrueData.isExUserOpen=     false;
                    this.queryTrueData.isExUserOpenRate= false;
                    this.queryTrueData.isPerVideoRate=   false;
                    this.queryTrueData.isJumpRate=       false;
                    this.queryTrueData.isOpen=           false;
                    this.queryTrueData.isVideoOpen=      false;
                    this.queryTrueData.isOnline=         false;
                    this.queryTrueData.isSubChannelName= false;
                    this.queryTrueData.isVideoRequestOpen = false;
                    this.queryTrueData.isPerVideoRequestTimes = false;
                    this.queryTrueData.isArpu = false;
                    this.queryTrueData.isPerValue = false;
                    this.queryTrueData.isEcpm =  false;
                }
            },


            exportExcel() {
                let fileName = new Date().toLocaleString() + '游戏日报.xlsx';
                downloadData(
                    '/game/searchGameReportExcel',
                    Object.assign(this.queryTrueData),
                    fileName
                )
            },


            queryGameReportList(){
                this.subQueryData = { ...this.queryData };
                let newLabelIds =[];// eslint-disable-line no-unused-vars
                 this.subQueryData.gameLabels.forEach(function (label) {
                      label.forEach(function (sub,index) {
                         if(index%2!==0){
                             newLabelIds.push(sub);
                         }
                      })
                 });
                 this.subQueryData.gameLabelIds=newLabelIds;
                    if (this.subQueryData.timeDate===null){
                       this.subQueryData.timeDate=['',''];
                    }
                    this.queryTrueData.gameLabelIds=this.subQueryData.gameLabelIds;
                    this.queryTrueData.user= this.subQueryData.user;
                    this.queryTrueData.gameIds=this.subQueryData.gameIds;
                    this.queryTrueData.channelId=this.subQueryData.channelId;
                    this.queryTrueData.subChannelId=this.subQueryData.subChannelId;
                    this.queryTrueData.startTime= this.subQueryData.timeDate[0];
                    this.queryTrueData.endTime=this.subQueryData.timeDate[1];
                    this.queryTrueData.size=this.queryInfo.pagesize;
                    this.queryTrueData.page=this.queryInfo.pagenum;
                    gameSearchGameReport(this.queryTrueData).then(resp=>{
                        this.gameReportList=resp.data.info.list;
                        this.queryInfo.total= resp.data.info.totalElements;
                    });
            },
            sortChange(order) {
                this.queryTrueData.order = order.order;
                this.queryTrueData.prop = order.prop;
                this.queryGameReportList();
            },
            jumpUserBehaviorPage(){
                this.$router.push({ path: '/userBehaviorReport'});
            },
            jumpUserGamePage(){
                this.$router.push({ path: '/userGameReport'});
            },
            jumpAdReportPage(){
                this.$router.push({ path: '/adReport'});
            }
        },

        watch:{
          watchTag(){
              this.queryData.subChannelId=[];
          }
        },

        created () {
            this.queryData.timeDate=[utils.TodayUtil.getToday(),utils.TodayUtil.getToday()];
            channelList().then(resp=>{
                this.channelList=resp.data.info;
            });
            gameSimpleList().then(resp=>{
                this.gameList=resp.data.info;
                this.gameList.unshift({id:-1,name:'游戏中心'});
            });

            // 获取游戏标签
            allGameLabels().then(resp=>{
                this.labelList=resp.data.info;
            });

           this.queryGameReportList();
        },
    }
</script>

<style scoped>
    .sub-sub4{ position: relative; left: 50px}
    .std{ position: relative; left: 20px}
</style>
